import client from './client';

export const supportTicketsAPI = {
  // User Actions
  getUserTickets: () => client.get('/support-tickets'),
  createTicket: (data) => client.post('/support-tickets', data),
  getTicketDetails: (id) => client.get(`/support-tickets/${id}`),

  // Admin Actions
  getAdminTickets: (status) => {
    const url = status ? `/support-tickets/admin/all?status=${status}` : '/support-tickets/admin/all';
    return client.get(url);
  },
  updateTicketStatus: (id, data) => client.patch(`/support-tickets/admin/${id}/status`, data)
};
